<mat-card appearance="outlined" class="color-card flex-lt-sm-100 box-shadow" style="display: flex; flex-direction: column">
  <colimo-color
    [gradient]="project.gradient"
    [hasWarning]="project.warning"
    [imgJpeg]="project.imgJpeg"
    [alerts]="project.userAlertData"
    class="flex-column-1 flex-column-lt-sm-35"
  ></colimo-color>
  <div class="flex-column-1 flex-column-lt-sm-65">
    <span class="color-name" [ngClass]="isMobile === true ? 'mobile-color-name' : ''">
      {{ project.name }}
    </span>
    <div class="flex-row gap-30">
      <div class="flex-50"></div>
      <p class="flex-50 recent-details" [ngClass]="isMobile === true ? 'mobile-font-size' : ''">
        {{ 'dashboard.recentLine' | translate }}
      </p>
    </div>
    <div class="detail-box">
      @if (hasInLineBatches) {
        <mat-grid-list cols="2" rowHeight="14px">
          @for (productBatch of productBatches; track i; let i = $index) {
            <div>
              <div class="grid-tile-product-batch">
                <mat-grid-tile [colspan]="productBatch.inLineBatches.length === 0 ? 2 : 1" [rowspan]=Math.max(productBatch.inLineBatches.length,1)>
                  <div [matTooltip]="productBatch.product.type" matTooltipPosition="before" class="grid-text" [ngClass]="isMobile === true ? 'mobile-font-size' : ''">
                    {{ productBatch.product.name }}
                  </div>
                </mat-grid-tile>
                @for (inLineBatch of productBatch.inLineBatches; track i; let i = $index) {
                  <mat-grid-tile [colspan]="1" [rowspan]="1">
                    <div [matTooltip]="productBatch.product.name" matTooltipPosition="above" class="grid-text batch-text-margin" [ngClass]="isMobile === true ? 'mobile-font-size' : ''">
                      {{ inLineBatch.batchNumber }}
                      @if (inLineBatch && inLineBatch.newBatchAlertId) {
                        <mat-icon class="new-batch-circle">circle</mat-icon>
                      }
                    </div>
                  </mat-grid-tile>
                }
              </div>
            </div>
          }
        </mat-grid-list>
      } @else {
        <mat-grid-list cols="2" rowHeight="14px">
          @for (productBatch of productBatches; track i; let i = $index) {
            <div>
              <div class="grid-tile-product-batch">
                <mat-grid-tile [colspan]="1" [rowspan]=1>
                  <div [matTooltip]="productBatch.product.type" matTooltipPosition="before" class="grid-text" [ngClass]="isMobile === true ? 'mobile-font-size' : ''">
                    {{ productBatch.product.name }}
                  </div>
                </mat-grid-tile>
                @if (i === 0) {
                  <mat-grid-tile [colspan]="1" [rowspan]="productBatches.length">
                    <div class="grid-text batch-text-margin" [ngClass]="isMobile === true ? 'mobile-font-size' : ''">--</div>
                  </mat-grid-tile>
                }
              </div>
            </div>
          }
        </mat-grid-list>
      }
    </div>
  </div>
</mat-card>
